const localePath = '../../dashboard/js/locale/';

export default {
    en: require('../../../dashboard/js/locale/en.js'),
    ja: require('../../../dashboard/js/locale/ja.js'),
    ko: require('../../../dashboard/js/locale/ko.js'),
    cn: require('../../../dashboard/js/locale/cn.js'),
};
